export default __webpack_public_path__ + "static/media/Readability_01.4786acc1.png";